<template>
    <div ref="containerMessageDisplay" :style="{background: colors.message.messagesDisplay.bg}"
         class="container-message-display" @scroll="updateScrollState">
        <div v-if="loading" class="loader">
            <div class="message-loading"></div>
        </div>
        <div v-for="(message, index) in messages" :key="index" class="message-container">
            <MyMessage
                v-if="message.participantId == myself.id"
                :message="message"
                :myself="myself"
                :colors="colors"
            />
            <OtherMessage
                v-else :message="message"
                :other="other"
                :colors="colors"
                :typing="otherTyping"
            />
        </div>
        <ChatTyping v-if="otherTyping" :other="other" />
    </div>
</template>

<script>
    import MyMessage from './MyMessage.vue'
    import OtherMessage from './OtherMessage.vue'
    import ChatTyping from './ChatTyping.vue'

    export default {
        components:{
            MyMessage,
            OtherMessage,
            ChatTyping
        },
        props: {
            messages: {
                type: Object,
                required: true
            },
            myself: {
                type: Object,
                required: true
            },
            other: {
                type: Object,
                required: true
            },
            colors: {
                type: Object,
                required: true
            },
            loadMoreMessages: {
                type: Function,
                required: false,
                default: null
            },
            scrollBottom: {
                type: Object,
                required: true
            },
            otherTyping: {
                type: Boolean,
                required: true,
                default: false
            }
        },
        data() {
            return {
                updateScroll: true,
                lastMessage: null,
                loading: false,
            }
        },
        mounted() {
            this.goToBottom()
            this.$refs.containerMessageDisplay.dispatchEvent(new CustomEvent('scroll'))
        },
        watch: {
            otherTyping(newValue) {
                if(newValue) {
                    const currentScrollTop = this.$refs.containerMessageDisplay.scrollTop
                    this.$nextTick(() => {
                        this.$refs.containerMessageDisplay.scrollTop = (currentScrollTop + 42)
                    }) 
                }
            }
        },
        updated() {
            if (this.messages.length && !this.messageCompare(this.messages[this.messages.length - 1], this.lastMessage)) {
                
                if(this.updateScroll || (this.scrollBottom.messageSent && this.messages[this.messages.length - 1].participantId == this.myself.id) || (this.scrollBottom.messageReceived && this.messages[this.messages.length - 1].participantId != this.myself.id)){
                    this.goToBottom()
                    if (this.messages.length) {
                        this.lastMessage = this.messages[this.messages.length - 1]
                    }
                }
            }
        },
        methods: {
            /**
             * This function compare two messages without looking at the uploaded propertie.
             * This function has been implemented to prevent chat scrolling down after changing the message from 'uploaded = false' to 'uploaded = true'.
             * @param {Object} message1 the first message object 
             * @param {Object} message2 the second message object
             * @return {Boolean} true if the messages are equal and false if they are different
             */
            messageCompare(message1, message2){
                /**
                 * if one of the messages are null, you can safely compare the messages with '==='
                 */
                if(!message2 || !message1){
                    return message1 === message2
                }
                /**
                 * compare the immutable properties of a message
                 */
                let participant_equal = message1.participantId == message2.participantId
                let content_equal = message1.content == message2.content
                let timestamp_equal = message1.timestamp.valueOf() === message2.timestamp.valueOf()

                return  participant_equal && content_equal && timestamp_equal
            },
            updateScrollState({target: {scrollTop, clientHeight, scrollHeight}}) {
                this.updateScroll = scrollTop + clientHeight >= scrollHeight

                if (typeof this.loadMoreMessages === 'function' && scrollTop < 20) {
                    this.loading = true
                    this.loadMoreMessages(() => {
                        // console.log('load more messages: ', messages)
                        this.loading = false
                    })
                }
            },
            goToBottom() {
                let scrollDiv = this.$refs.containerMessageDisplay
                scrollDiv.scrollTop = scrollDiv.scrollHeight
                
                this.updateScroll = false
            }
        }
    }
</script>